import React, { Component } from "react";
import { Translate as T, I18n } from "react-redux-i18n";
import ReactGA from "react-ga";
import Prize from "../Prizes/Prize";

import styles from "./Solved.css";
import { yay } from "../../sounds";

import Dialog from "../Dialog/Dialog";
import HeadingCurved from "../HeadingCurved/HeadingCurved";
import Overlay from "../Overlay/Overlay";

export default class App extends Component {
  static defaultProps = {
    prizes: []
  };

  componentDidUpdate = prevProps => {
    if (this.props.show && prevProps.show !== this.props.show) {
      ReactGA.event({
        category: "Game",
        action: "Solved"
      });

      yay.play();
    }
  };

  getPrizesString = prizes =>
    prizes
      .map(prize => prize.name)
      .join(", ")
      .replace(/,(?!.*,)/gim, ` ${I18n.t("common.and")}`);

  render = () => (
    <Overlay show={this.props.show} onTop={false}>
      <div className={styles.solved}>
        <Dialog onClose={this.handleCloseClick}>
          <div className={styles.heading}>
            <HeadingCurved text={I18n.t("solved.heading")} />
          </div>
          <div className={styles.background}>
            {this.renderPrizes()}
            <p className={styles.body}>
              <T
                value="solved.body"
                prizes={this.getPrizesString(this.props.prizes)}
              />
            </p>
          </div>
        </Dialog>
        <div className={styles.buttons}>
          <button
            onClick={this.handleOneMoreClick}
            className={`${styles.button} ${styles.oneMore}`}
          >
            <T value="solved.oneMore" />
          </button>
          {this.props.level && (
            <button
              onClick={this.handleNextLevelClick}
              className={`${styles.button} ${styles.nextLevel}`}
            >
              <T value="solved.nextLevel" />
            </button>
          )}
        </div>
      </div>
    </Overlay>
  );

  renderPrizes = () =>
    this.props.prizes.length && (
      <div className={styles.prizes}>
        {this.props.prizes.map(prize => (
          <div key={prize.id} className={styles.prize}>
            <Prize prize={prize} />
          </div>
        ))}
      </div>
    );

  handleOneMoreClick = () => {
    this.props.hideSolved();
    this.props.nextSeed();

    ReactGA.event({
      category: "Tools",
      action: "Regenerate"
    });
  };

  handleNextLevelClick = () => {
    this.props.hideSolved();
    this.props.nextLevel();

    ReactGA.event({
      category: "Tools",
      action: "Next level"
    });
  };

  handleCloseClick = () => this.props.hideSolved();
}



// WEBPACK FOOTER //
// ./src/components/Solved/Solved.js